import type { StructureSummaryDto } from '~/backend/connector-next-api/connector-next-schemas';
import { asRoiId } from '~/domain/changes/ids';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomConstants';
import type { RecordedRoiReview } from '~/domain/provenance/RecordedRoiReview';
import { toRecordedDate, toRecordedUser } from './toRecordedDatasetOrigin';

/**
 * The structures' own reviews the connector recorded, one per reviewed
 * structure. A row without an id, or with a status the viewer does not
 * know, records no review rather than a guessed one.
 */
export function toRecordedRoiReviews(
    structures:
        | readonly Pick<
              StructureSummaryDto,
              | 'roiUid'
              | 'reviewStatus'
              | 'reviewedBy'
              | 'reviewedBySource'
              | 'reviewedAt'
          >[]
        | null
        | undefined
): RecordedRoiReview[] {
    const reviews: RecordedRoiReview[] = [];
    for (const structure of structures ?? []) {
        const status =
            structure.reviewStatus === 'Accepted'
                ? DICOMApprovalStatus.APPROVED
                : structure.reviewStatus === 'Rejected'
                  ? DICOMApprovalStatus.REJECTED
                  : null;
        if (!structure.roiUid || status === null) {
            continue;
        }
        reviews.push({
            roiId: asRoiId(structure.roiUid),
            status,
            reviewer: toRecordedUser(
                structure.reviewedBy,
                structure.reviewedBySource
            ),
            reviewedAt: toRecordedDate(structure.reviewedAt),
        });
    }
    return reviews;
}
